<template>
  <div>
    <app-nav></app-nav>
    <div class="container-fluid">
      <div class="row">
        <div class="col-sm-1"></div>
        <main class="col-sm-9 ml-sm-auto col-md-10 pt-3" role="main">
        <h5 class="text-left" >Liste des Interimaires</h5>
        <br>
        <div class="form-check row">
            <label class="form-check-label">
                <input class="form-check-input"  type="checkbox" id="checkbox" v-model="viewInactives" >
                Montrer aussi les intérimaires inactifs
            </label>
        </div>
        <div class="row">
            <router-link tag="button" class="btn btn-primary pull-left mb-2" :to="{name: 'InterimaireNew'} ">Nouvel intérimaire</router-link>   
        </div>
        <div class="table-responsive row">
        <table class="table table-striped">
            <thead>
            <tr>        
                <th>#</th>
                <th>Nom</th>
                <th>Prenom</th>
                <th>Actif</th>               
                <th></th>
            </tr>
            </thead>
            <tbody>
                <tr v-for="remp in filteredInterims()" :key="remp.node.id">          
         
                <th><router-link :to="{name: 'Interimaire' , params: { id: remp.node.id }}">{{remp.node.id}}  </router-link></th>     
                <th><router-link :to="{name: 'Interimaire' , params: { id: remp.node.id }}">{{remp.node.nom}}  </router-link></th>     
              
                <td class="text-left">{{ remp.node.prenom }}</td>
                <td class="text-left">{{ remp.node.actif ?"&#x2714;"  : "Non" }}</td>
                <td><button class="btn btn-danger btn-sm" @click="deleteInterim(remp.node.id)" :disabled="remp.node.actif === false">Suppr.</button></td>
                </tr>
            </tbody>
        </table>
        </div>    
          </main>
        </div>
    </div>
  </div>
</template>
<script>
import {filter} from 'lodash'
import AppNav from '../AppNav'
import {
  ALL_INTERIMS,
  UPDATE_INTERIM
} from '../../constants/interim'

export default {
  name: 'interims',
  components: {
    AppNav,
  },
  data() {
    return {  
      allInterimaires: {},
      viewInactives: false
    }
  },
  apollo: {
    allInterimaires: {
      query: ALL_INTERIMS
    }  
  },
  methods: {
    filteredInterims () {
      var self = this
      if (self.viewInactives == false) {
        return filter(self.allInterimaires.edges, function (interim) { 
          return interim.node.actif == true;
        })          
      } else {      
      return   self.allInterimaires.edges
      }
    },
        /*
        Don't truly delete !
        */
    deleteInterim(id){
      var self = this;
      this.$apollo.mutate({
        mutation: UPDATE_INTERIM,
        variables: {
          id: id,
          actif: false
        },
          refetchQueries: [{
              query: ALL_INTERIMS
          }]     
      }).then((data) => {
          self.$router.push({name: 'Interims'})
      }).catch((error) => {
        // Error
        console.error(error)
      })
      }
    }
  }
</script>
<style scoped>
body {
    padding-top: 3.5rem;
   
}

h1 {
    margin-bottom: 20px;
    padding-bottom: 9px;
    border-bottom: 1px solid #eee;
}

.sidebar {
    position: fixed;
    top: 51px;
    bottom: 0;
    left: 0;
    z-index: 1000;
    padding: 20px;
    overflow-x: hidden;
    overflow-y: auto;
    /* Scrollable contents if viewport is shorter than content. */
    border-right: 1px solid #eee;
}


/* Sidebar navigation */

.sidebar {
    padding-left: 0;
    padding-right: 0;
}

.sidebar .nav {
    margin-bottom: 20px;
}

.sidebar .nav-item {
    width: 100%;
}

.sidebar .nav-item+.nav-item {
    margin-left: 0;
}

.sidebar .nav-link {
    border-radius: 0;
}


/*
 * Dashboard
 */


/* Placeholders */

.placeholders {
    padding-bottom: 3rem;
}

.placeholder img {
    padding-top: 1.5rem;
    padding-bottom: 1.5rem;
}

select option[data-default] {
    display: none;
}

.medecins-form{
    padding-bottom: 60px;
}


</style>



// WEBPACK FOOTER //
// interims.vue?3b199894